<template>
  <div class="form-section">
    <div v-if="title"
      class="form-section__title">
      {{ title }}
      <slot name="after-title" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'form-section',
  props: {
    title: { type: String, default: '' },
  }
}
</script>

<style>
.form-section {
  margin-bottom: 20rem;
  display: flex;
  flex-direction: column;
  gap: 10rem;
}

.form-section__title {
  font-size: 14rem;
  font-weight: 600;
  color: var(--primary);
  text-transform: uppercase;
  letter-spacing: 0.5rem;
  margin-bottom: 10rem;
  padding-bottom: 6rem;
  border-bottom: 1rem solid var(--border-color, #e0e0e0);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8rem;
}
</style>
